import DownloadProcess from '@/models/DownloadProcess/DownloadProcess';

export default class DownloadProcessFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.jobId = '';
		this.functionId = '';
		this.fileName = '';
		this.startTimeFrom = '';
		this.startTimeTo = '';
		this.endTimeFrom = '';
		this.endTimeTo = '';
		this.status = '';
		this.errorMessageMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			jobId : '0',
			functionId : '0',
			fileName : '0',
			startTimeFrom : '0',
			startTimeTo : '0',
			endTimeFrom : '0',
			endTimeTo : '0',
			status : '0',
			errorMessageMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}